import { SVG, SVGProps } from './svg'

export function IconCandleBarBasic(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 30 30">
      <path d="M16 3h-1v5h-3v14h3v5h1v-5h3V8h-3V3Z" />
    </SVG>
  )
}
